import { RotateCwIcon, WifiOffIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/ui/button';
import { Spinner } from '@/shared/ui/spinner';

import { bootstrapSession, useBootStore } from './session';

/** Full-screen state while the session is restored; offers a retry when the API is unreachable. */
export function SessionSplash() {
  const { t } = useTranslation('shared');
  const failed = useBootStore((s) => s.failed);
  return (
    <div
      className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-surface px-6 text-center"
      role="status"
    >
      {failed ? (
        <>
          <span className="flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <WifiOffIcon className="size-5" />
          </span>
          <div className="space-y-1">
            <p className="font-semibold">{t('session.unreachableTitle')}</p>
            <p className="text-sm text-muted-foreground">{t('session.unreachableHint')}</p>
          </div>
          <Button variant="outline" onClick={() => void bootstrapSession()}>
            <RotateCwIcon />
            {t('actions.retry')}
          </Button>
        </>
      ) : (
        <>
          <Spinner className="size-6" />
          <span className="sr-only">{t('states.loading')}</span>
        </>
      )}
    </div>
  );
}
